<template>
    <div class="page-container">
        <div class="page-title">预算</div>
        <div class="yusuan-section">
            <div class="ys-item">
                <div class="item-num">{{estimateAmount}}</div>
                <div class="item-text">预计进货总额(元)</div>
            </div>
            <div class="ys-item">
                <div class="item-num">{{pageData.amount | toPrice}}</div>
                <div class="item-text">当前账户余额(元)</div>
            </div>
        </div>
        <div class="page-title" style="margin-top:15px;margin-bottom:0;">选择进货商品</div>
        <div class="list">
            <div class="incentive-item" v-for="(item,index) in goodsList" :key="index">
                <div class="goods-info-block">
                    <img :src="item.picUrl" class="goods-pic">
                    <div class="goods-detail">
                        <div class="goods-name">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                        <div class="goods-sku">
                            <span>整箱(6瓶)</span>
                            <!-- 秋实 、冬藏两款酒不需要限制5的倍数 -->
                            <van-stepper v-model="item.number" integer v-if="item.goodsSn == 'YL-QS-001' || item.goodsSn == 'YL-DC-001'" min="0" step="1" button-size="22" @change="calcPay" />
                            <van-stepper v-model="item.number" integer v-else min="0" step="5" button-size="22" @change="calcPay" />
                        </div>
                        <div class="caigou-price">采购价：¥{{item.price}}/瓶</div>
                    </div>
                </div>
                <!-- 赠送商品信息 -->
                <div class="presentation-block">
                    <div class="present-left">
                        <div class="goods-pic">
                            <img :src="item.picUrl" alt="">
                            <img src="../../assets/tag-zs.png" alt="" class="tag">
                        </div>
                        <div class="goods-info">
                            <div class="goods-name">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                            <!-- <div class="sku">整箱(6瓶)</div> -->
                        </div>
                    </div>
                    <div class="present-right">
                        <div class="present-right-wrapper">
                            x{{item.number * item.sendNum}}(箱)
                        </div>
                    </div>
                </div>
                <!-- 奖励商品信息 -->
                <div class="presentation-block" v-if="item.rewardNum != 0">
                    <div class="present-left">
                        <div class="goods-pic">
                            <img :src="item.picUrl" alt="">
                            <img src="../../assets/tag-jl.png" alt="" class="tag">
                        </div>
                        <div class="goods-info">
                            <div class="goods-name">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                            <div class="sku" style="color:#E43D3D;">奖品将在您下次补款成功时释放</div>
                        </div>
                    </div>
                    <div class="present-right">
                        <div class="present-right-wrapper">
                            x{{item.number * item.rewardNum}}(箱)
                        </div>
                    </div>
                </div>
                <div class="item-bottom">
                    <!-- <span>总数：{{item.number + (item.number * pageData.sendNum)}}箱</span> -->
                    <span>总价：¥{{(item.number * item.price * 6) | toPrice}}</span>
                    
                </div>
            </div>
        </div>
        <div class="bottom-notice" v-show="estimateAmount > pageData.amount">您的账户当前余额不足，请先去补货，或减少提货数量</div>
        <div class="btn-confirm" v-show="estimateAmount <= pageData.amount" @click="confirm">提交订单</div>
        <div class="btn-confirm" v-show="estimateAmount > pageData.amount" style="background:#dcdcdc;color:#999;">确认进货</div>
    </div>
</template>

<script>
import { Stepper,Toast } from 'vant'

import $http from '@/lib/request'
import config from '@/config'
export default {
    data(){
        return {
            number:1,
            estimateAmount:0,//预计进货总额
            pageData:{},//页面数据
            goodsList:[],//商品列表
        }
    },
    components:{
        [Stepper.name]:Stepper,
        [Toast.name]:Toast
    },
    filters:{
        toPrice:function(value){
            return Number(value).toFixed(2);
        }
    },
    activated(){
        $http({
            method:'post',
            url:config.api.pickApply
        }).then(res=>{
            if(res.errno == 0){
                let tmpGoodslist=res.data.goodsList;
                for(let i=0;i<tmpGoodslist.length;i++){
                    //将每款商品购买数量初始化为5
                    tmpGoodslist[i].number=0;
                }
                this.pageData=res.data;
                this.goodsList=tmpGoodslist;
                //计算预计花费
                this.calcPay();
            }else{
                Toast(res.errmsg);
            }
        })
    },
    deactivated(){
        this.number=1;
        this.estimateAmount=0;//预计进货总额
        this.pageData={};//页面数据
        this.goodsList=[];//商品列表
    },
    methods:{
        //计算进货预计花费
        calcPay(){
            let list=this.goodsList;
            let totalPay=0;
            for(let i=0,len=list.length;i<len;i++){
                totalPay += Number(list[i].number * list[i].price * 6);
            }
            this.estimateAmount=totalPay.toFixed(2);
        },
        //确认进货
        confirm(){
            let body=[],
                list=this.goodsList;
            for(let i=0,len=list.length;i<len;i++){
                body.push({
                    goodsId:list[i].id,
                    num:list[i].number
                });
            }
            $http({
                method:'post',
                data:{
                    body:body
                },
                url:config.api.preconfirmPickapply
            }).then(res=>{
                if(res.errno == 0){
                    this.$router.push({ name: 'pickup-confirm', params: { oid: res.data }})
                }else{
                    Toast(res.errmsg);
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-container{
    min-height:calc(100vh - 46px);
    box-sizing: border-box;
    background:#f5f5f5;
    padding:10px;
    padding-bottom: 66px;
    .page-title{
        font-size: 16px;
        color:#000;
        line-height: 22px;
        margin-bottom: 10px;
    }
    .yusuan-section{
        background:#fff;
        border-radius: 4px;
        padding:20px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .ys-item{
            width:50%;
            text-align: center;
            &:first-child{
                border-right: 1px solid #e6e6e6;
            }
            .item-num{
                color:#3088F5;
                font-size: 20px;
                line-height: 24px;
                margin-bottom: 5px;
                font-weight: bold;
                font-family: DINAlternate-Bold, DINAlternate;
            }
            .item-text{
                color:#333;
                font-size: 14px;
                line-height: 20px;
            }
        }
    }
    .list{
        margin-top: 10px;
        .incentive-item{
            background:#fff;
            border-radius: 4px;
            padding:0 15px;
            margin-bottom: 10px;
            position: relative;
            &::after,&::before{
                content:'';
                display: block;
                width:20px;
                height:20px;
                border-radius: 50%;
                background:#f5f5f5;
                position: absolute;
                top:106px;
            }
            &::before{
                left:-10px;
            }
            &::after{
                right:-10px;
            }
            .goods-info-block{
                display: flex;
                justify-content: flex-start;
                padding:15px 0;
                .goods-pic{
                    width:80px;
                    height:80px;
                    margin-right: 10px;
                    border-radius: 4px;
                }
                .goods-detail{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width:calc(100% - 70px);
                    .goods-name{
                        overflow: hidden;
                        text-overflow:ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        color:#000;
                        line-height: 20px;
                        font-size: 14px;
                    }
                    .goods-sku{
                        @include flex-between();
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                    .caigou-price{
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                }
            }
            .presentation-block{
                position: relative;
                margin-top: 30px;
                @include flex-between();
                .present-left{
                    width:280px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;
                    .goods-pic{
                        width:50px;
                        height:50px;
                        border-radius: 4px;
                        overflow: hidden;
                        position: relative;
                        margin-right: 10px;
                        &>img{
                            display: block;
                            width:100%;
                            height:100%;
                        }
                        .tag{
                            position: absolute;
                            top:0;
                            left:0;
                            width:24px;
                            height:14px;
                        }
                    }
                    .goods-info{
                        width:220px;
                        height:50px;
                        display: flex;
                        justify-content: space-between;
                        flex-direction: column;
                        .goods-name{
                            font-size: 12px;
                            color:#000;
                            line-height: 18px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .sku{
                            color:#999;
                            font-size: 10px;
                            line-height: 14px;
                        }
                    }
                }
                .present-right{
                    width:71px;
                    height:54px;
                    font-size: 12px;
                    color: #999;
                    background:url('../../assets/count-box.png') no-repeat center center;
                    background-size: 71px 54px;
                    display: flex;
                    align-items: center;
                    .present-right-wrapper{
                        width:60px;
                        text-indent: 11px;
                        text-align: center;
                        color:#3088F5;
                    }
                }
            }
            .item-bottom{
                text-align: right;
                font-size: 14px;
                line-height: 20px;
                padding-bottom: 15px;
                margin-top: 15px;
                &>span:first-child{
                    color:#999;
                }
                &>span:last-child{
                    color:#333;
                    margin-left: 15px;
                }
            }
        }
    }
    .bottom-notice{
        margin-top: 30px;
        font-size: 12px;
        line-height: 17px;
        color:#E43D3D;
        text-align: center;
    }
    .btn-confirm{
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        font-size: 14px;
        color:#fff;
        position: fixed;
        bottom:20px;
        left:50%;
        transform: translateX(-50%);
        @media screen and (max-width:750px){
            border-radius: 26px;
        }
    }
}
</style>